import React from 'react';

import { DatePicker } from 'components/modules/Insurance/components/DatePicker/DatePicker';
import { FormWrapper } from 'components/modules/Insurance/components/FormWrapper/FormWrapper';
import {
  MAX_DATE,
  MIN_DATE,
  NUMBER_MAX_99_MASK,
  OUTPUT_CUSTOMER_DATE_FORMAT,
} from 'components/modules/Insurance/Insurance.constants';
import { Button } from 'components/uikit/Button/Button';
import { DRIVER_FIELDS } from 'store/insuranceAnketa/constants';
import { InputMask } from 'utils/inputMask';

import { useDriverCardPresenter } from './DriverCard.presenter';
import * as S from './DriverCard.styles';

export const DriverCard = ({ id }) => {
  const presenter = useDriverCardPresenter({ id });

  return (
    <>
      <S.Container>
        <S.Header>
          <S.HeaderContent>
            <S.Title>{presenter.title}</S.Title>
            {presenter.description ? <S.Description>{presenter.description}</S.Description> : null}
          </S.HeaderContent>
          <S.HeaderControls>
            {!presenter.editing && (
              <S.EditButton disabled={presenter.disabled} onClick={presenter.onStartEdit} />
            )}
            {!presenter.empty && (
              <S.RemoveButton disabled={presenter.disabled} onClick={presenter.onOpenPopup} />
            )}
          </S.HeaderControls>
        </S.Header>
        {presenter.editing ? (
          <>
            <FormWrapper>
              <S.Genders
                disabled={presenter.disabled}
                name={DRIVER_FIELDS.GENDER}
                value={presenter.values[DRIVER_FIELDS.GENDER]}
                onChange={presenter.onChangeGender}
              />
              <S.FullNameInputs
                disabled={presenter.disabled}
                error={presenter.errors[DRIVER_FIELDS.FULL_NAME]}
                name={DRIVER_FIELDS.FULL_NAME}
                value={presenter.values[DRIVER_FIELDS.FULL_NAME]}
                onChange={presenter.onChange}
                onChangeGender={presenter.onChangeGender}
              />
              <S.TextInputMasked
                disabled={presenter.disabled}
                error={presenter.errors[DRIVER_FIELDS.DRIVING_LICENSE_SERIES_AND_NUMBER]}
                label="Серия и номер ВУ"
                mask={InputMask.DRIVE_LICENSE_SERIES_NUMBER}
                name={DRIVER_FIELDS.DRIVING_LICENSE_SERIES_AND_NUMBER}
                unmask={false}
                value={presenter.values[DRIVER_FIELDS.DRIVING_LICENSE_SERIES_AND_NUMBER]}
                onChange={presenter.onChange}
              />
              <DatePicker
                disabled={presenter.disabled}
                error={presenter.errors[DRIVER_FIELDS.DRIVING_LICENSE_ISSUE_DATE]}
                label="Дата выдачи ВУ"
                maxDate={MAX_DATE}
                minDate={MIN_DATE}
                name={DRIVER_FIELDS.DRIVING_LICENSE_ISSUE_DATE}
                outputFormat={OUTPUT_CUSTOMER_DATE_FORMAT}
                value={presenter.values[DRIVER_FIELDS.DRIVING_LICENSE_ISSUE_DATE]}
                onChange={presenter.onChange}
              />
              <DatePicker
                disabled={presenter.disabled}
                error={presenter.errors[DRIVER_FIELDS.BIRTHDATE]}
                label="Дата рождения"
                maxDate={MAX_DATE}
                minDate={MIN_DATE}
                name={DRIVER_FIELDS.BIRTHDATE}
                outputFormat={OUTPUT_CUSTOMER_DATE_FORMAT}
                value={presenter.values[DRIVER_FIELDS.BIRTHDATE]}
                onChange={presenter.onChange}
              />
              <S.TextInputMasked
                disabled={presenter.disabled}
                error={presenter.errors[DRIVER_FIELDS.DRIVING_EXPERIENCE]}
                label="Стаж вождения"
                mask={NUMBER_MAX_99_MASK}
                name={DRIVER_FIELDS.DRIVING_EXPERIENCE}
                value={presenter.values[DRIVER_FIELDS.DRIVING_EXPERIENCE]}
                onChange={presenter.onChange}
              />
            </FormWrapper>
            <S.Controls>
              <Button disabled={presenter.disabled} theme="3" onClick={presenter.onEndEdit}>
                Отменить
              </Button>
              <Button
                disabled={!presenter.changed || presenter.disabled}
                theme="1"
                onClick={presenter.onSave}
              >
                Сохранить
              </Button>
            </S.Controls>
          </>
        ) : null}
      </S.Container>
      <S.Popup isOpen={presenter.isPopupVisible} onClose={presenter.onClosePopup}>
        <S.PopupTitle>Удалить водителя?</S.PopupTitle>
        <S.PopupDescription>
          Если&nbsp;водитель будет удалён, его&nbsp;нельзя будет вернуть — придётся добавлять его
          заново
        </S.PopupDescription>
        <S.PopupControls>
          <Button theme="4" onClick={presenter.onDelete}>
            Да
          </Button>
          <Button theme="1" onClick={presenter.onClosePopup}>
            Нет
          </Button>
        </S.PopupControls>
      </S.Popup>
    </>
  );
};
